module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 040.e78b698a.jpg";